import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, Content } from 'ionic-angular';
import { ConfigService, SportsFilter, SportsFilterService, Sportshome, SportsHomeService } from 'baseline-lib';
import { SportsMenuPage } from '../sports-menu-page/sports-menu-page';
import { SportsBetslipPage } from '../sports-betslip/sports-betslip';
import { SportsFullDetailPage } from '../sports-full-detail/sports-full-detail';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';
import { Global } from '../../../global/global';
/**
 * Generated class for the SportsDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage({
//   name: 'page-sports-detail',
//   segment: 'page-sports-detail/:id/:tid'
// })
@IonicPage()
@Component({
  selector: 'page-sports-detail',
  templateUrl: 'sports-detail.html',
})
export class SportsDetailPage {
@ViewChild(Content) content: Content;

  _sportsFilter: SportsFilter;
  params : any;
  sportsHomeObj: Sportshome;
  pageFrom : string;
  
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public _configService : ConfigService, public _sportsFilterService: SportsFilterService,
    public _sportsHomeService : SportsHomeService,public modalCtrl : ModalController, public globalData : Global) 
  {
   // this._sportsFilter = new SportsFilter();
    this.sportsHomeObj = new Sportshome();
    this.pageFrom = "sportsDetail";
  }

  ngOnInit() {
    this.globalData.isLoaderShowninDetailPage = true;
     this._sportsHomeService.setSportsGame();
     this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
  }

  openSportsMenuPage(){
    this.navCtrl.push(SportsMenuPage);
  }

  openBetSlipPage(){
    this.navCtrl.push(SportsBetslipPage);
  }  

  loginClicked()
  {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();    
  }

  registerClicked()
  {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }

  ngOnDestroy(){
    this.globalData.isLoaderShowninDetailPage = false;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/sports/sports-detail/sports-detail.ts